import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const insertMobile = async (data: InsertMobileReqT) =>
  axios.post(Routes.INSERT_MOBILE, data);

export const useInsertMobile = () =>
  useMutation({
    mutationKey: [Keys.INSERT_MOBILE_MUT],
    mutationFn: insertMobile,
  });
